"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
class RcReactTablePaginationManager extends _react.default.Component {
  constructor(props) {
    super(props);
    _defineProperty(this, "changePage", event => {
      const {
        page,
        onPageChange
      } = this.props;
      const changePageTo = event.detail.page;
      if (page !== changePageTo) {
        onPageChange(changePageTo);
      }
    });
    this.changePage = this.changePage.bind(this);
    this.bubblePageInfo = this.bubblePageInfo.bind(this);
    const {
      tableIdentifer
    } = props;
    window.document.addEventListener(`rc-react-table-page-change-${tableIdentifer}`, this.changePage);
  }
  componentDidMount() {
    this.bubblePageInfo();
  }
  componentDidUpdate() {
    this.bubblePageInfo();
  }
  componentWillUnmount() {
    const {
      tableIdentifer
    } = this.props;
    window.document.removeEventListener(`rc-react-table-page-change-${tableIdentifer}`, this.changePage);
  }
  bubblePageInfo() {
    const {
      tableIdentifer,
      page,
      pageSize,
      pages,
      canPrevious,
      canNext,
      loading,
      selected
    } = this.props;
    let event;
    if (typeof Event === 'function') {
      event = new window.CustomEvent(`rc-react-table-pageinfo-update-${tableIdentifer}`, {
        bubbles: true,
        detail: {
          page,
          pageSize,
          totalPages: pages,
          canPrevious,
          canNext,
          isLoading: loading,
          selected
        }
      });
    } else {
      event = window.document.createEvent('Event');
      event.initEvent(`rc-react-table-pageinfo-update-${tableIdentifer}`, true, true);
      event.detail = {
        page,
        pageSize,
        totalPages: pages,
        canPrevious,
        canNext,
        isLoading: loading,
        selected
      };
    }
    window.document.dispatchEvent(event);
  }
  render() {
    // Rendering takes place in RcReactTablePagination and RcReactTablePageInfo based on events
    return null;
  }
}
exports.default = RcReactTablePaginationManager;
RcReactTablePaginationManager.propTypes = {
  tableIdentifer: _propTypes.default.string,
  page: _propTypes.default.number.isRequired,
  pages: _propTypes.default.number.isRequired,
  pageSize: _propTypes.default.number.isRequired,
  canNext: _propTypes.default.bool.isRequired,
  canPrevious: _propTypes.default.bool.isRequired,
  onPageChange: _propTypes.default.func.isRequired,
  loading: _propTypes.default.bool.isRequired,
  selected: _propTypes.default.number
};
RcReactTablePaginationManager.defaultProps = {
  tableIdentifer: 'default'
};
//# sourceMappingURL=RcReactTablePaginationManager.js.map